import { DateTime } from 'luxon'

export default (date, format = 'dd/MM/yyyy HH:mm:ss') => {
  if (!date) return '-'
  return DateTime.fromISO(date).toFormat(format)
}
